import { apiV2Instance } from '../../lib/api-v2.client';

export class AppService {
  getAppDetails() {
    return apiV2Instance.get(`/api/public`, { silent: true }).then(response => {
      return response.data;
    });
  }
}
